import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './online-learning-glossary.component.html',
  styleUrls: ['./online-learning-glossary.component.scss']
})
export class OnlineLearningGlossaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
